import getTheme from '@shared/utils/getTheme';
import styles from '@core/theme/styles/scss/shared/colors.module.scss';

const shared = {
  colors: styles,
};

export default getTheme(shared);
